(() => {
  'use-strict';

  // Execute once at load.
  window.dataLayer = window.dataLayer || [];
  const utmDataLayer = JSON.parse(sessionStorage.getItem('utm-values'));
  /* eslint-disable no-undef */
  let datas = { ...dataLayer[0] };
  if ((utmDataLayer === null && datas.campagne !== 'organic') || (utmDataLayer !== null && datas.campagne !== utmDataLayer.campagne && datas.campagne !== 'organic')) {
    // SEA Campaign, UTM in URL.
    sessionStorage.setItem('utm-values', JSON.stringify({
      campagne: datas.campagne,
      medium: datas.medium,
      source: datas.source,
      content: datas.content,
      term: datas.term,
    }));
  } else if (utmDataLayer !== null && datas.campagne === 'organic') {
    dataLayer = [{ ...datas, ...utmDataLayer }];
  }

  function initDataLayer(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initDataLayer' in element.dataset) {
        return;
      }
      element.dataset.initDataLayer = true;

      const newDataLayer = JSON.parse(element.dataset.layer);
      const pageNamePrefix = newDataLayer.pagenameprefix;

      // eslint-disable-next-line no-undef
      datas = { ...dataLayer.find((o) => o.typepage) };

      if (Object.keys(datas).length === 0) {
        /* eslint-disable-next-line no-console */
        console.warn('dataLayer GTM datas not found!');
        return;
      }
      const pageNameSplit = datas.pagename.split('_');

      if (datas.event) {
        delete datas.event;
      }
      if (datas.pagenameprefix) {
        delete datas.pagenameprefix;
      }

      if (pageNamePrefix) {
        if (['brochure', 'contact'].includes(pageNameSplit[0])) {
          pageNameSplit.shift();
        }
        datas.pagename = `${pageNamePrefix}_${pageNameSplit.join('_')}`;
      }

      /* eslint-disable no-undef */
      dataLayer.push({ ...datas, ...newDataLayer });

      const inputUtmName = element.querySelector('[name="utm_name"]');
      const inputUtmMedium = element.querySelector('[name="utm_medium"]');
      const inputUtmSource = element.querySelector('[name="utm_source"]');
      const inputUtmContent = element.querySelector('[name="utm_content"]');
      const inputUtmTerm = element.querySelector('[name="utm_term"]');

      if (inputUtmName !== null) {
        inputUtmName.value = datas.campagne;
        inputUtmMedium.value = datas.medium;
        inputUtmSource.value = datas.source;
        inputUtmContent.value = datas.content;
        inputUtmTerm.value = datas.term;
      }
      /* eslint-enable */
    });
  }

  Drupal.behaviors.dataLayer2 = {
    attach: () => {
      const dynamicDataLayer = document.querySelectorAll('[data-layer]');
      if (dynamicDataLayer.length !== 0) {
        initDataLayer(dynamicDataLayer);
      }
    },
  };
})();
